// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2JPoV","left":"StickyBox_left__hU3AS","right":"StickyBox_right__2LTSz"};